module.exports = __webpack_public_path__ + "img/__red_rocket03.eb2a1020.svg";